<template>
  <v-app id="app">
    <CorePatientsAppBar />
    <core-patients-drawer />
    <core-view />
    <snackbars />
  </v-app>
</template>

<script>
import Snackbars from "@/plugins/notifications/Snackbars";
import ToolbarAvatar from "@/components/ToolbarAvatar";
import CorePatientsDrawer from "@/views/layouts/core/CorePatientsDrawer";
import CorePatientsAppBar from "@/views/layouts/core/CorePatientsAppBar";
import CoreView from "@/views/layouts/core/CoreView";

export default {
  name: "DefaultLayout",

  components: {
    CoreView,
    CorePatientsAppBar,
    CorePatientsDrawer,
    ToolbarAvatar,
    Snackbars,
  },

  data: () => ({
    drawer: null,
    showMenu: true,
  }),

  created() {
    // Получение глобальных GET параметров
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("showMenu")) {
      this.showMenu = true;
    }
  },
};
</script>

<style scoped lang="scss"></style>
